import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
function enumStringToValue$3(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class PartnerEngagement {
  static fromProto(proto) {
    let m = new PartnerEngagement();
    m = Object.assign(m, proto);
    if (proto.enabledOn) {
      m.enabledOn = new Date(proto.enabledOn);
    }
    if (proto.totalStoreViews) {
      m.totalStoreViews = parseInt(proto.totalStoreViews, 10);
    }
    if (proto.totalStoreCallToActionEvents) {
      m.totalStoreCallToActionEvents = parseInt(proto.totalStoreCallToActionEvents, 10);
    }
    if (proto.totalActivations) {
      m.totalActivations = parseInt(proto.totalActivations, 10);
    }
    if (proto.totalDeactivations) {
      m.totalDeactivations = parseInt(proto.totalDeactivations, 10);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.totalPartnerViews) {
      m.totalPartnerViews = parseInt(proto.totalPartnerViews, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.partnerName !== 'undefined') {
      toReturn['partnerName'] = this.partnerName;
    }
    if (typeof this.enabledOn !== 'undefined' && this.enabledOn !== null) {
      toReturn['enabledOn'] = 'toApiJson' in this.enabledOn ? this.enabledOn.toApiJson() : this.enabledOn;
    }
    if (typeof this.selling !== 'undefined') {
      toReturn['selling'] = this.selling;
    }
    if (typeof this.totalStoreViews !== 'undefined') {
      toReturn['totalStoreViews'] = this.totalStoreViews;
    }
    if (typeof this.totalStoreCallToActionEvents !== 'undefined') {
      toReturn['totalStoreCallToActionEvents'] = this.totalStoreCallToActionEvents;
    }
    if (typeof this.totalActivations !== 'undefined') {
      toReturn['totalActivations'] = this.totalActivations;
    }
    if (typeof this.totalDeactivations !== 'undefined') {
      toReturn['totalDeactivations'] = this.totalDeactivations;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.salesContactEmail !== 'undefined') {
      toReturn['salesContactEmail'] = this.salesContactEmail;
    }
    if (typeof this.totalPartnerViews !== 'undefined') {
      toReturn['totalPartnerViews'] = this.totalPartnerViews;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var ResellerServiceTier = /*#__PURE__*/function (ResellerServiceTier) {
  ResellerServiceTier[ResellerServiceTier["RESELLER_SERVICE_TIER_INVALID"] = 0] = "RESELLER_SERVICE_TIER_INVALID";
  ResellerServiceTier[ResellerServiceTier["RESELLER_SERVICE_TIER_PRE_SALES"] = 1] = "RESELLER_SERVICE_TIER_PRE_SALES";
  ResellerServiceTier[ResellerServiceTier["RESELLER_SERVICE_TIER_CHURNED_PARTNER"] = 2] = "RESELLER_SERVICE_TIER_CHURNED_PARTNER";
  ResellerServiceTier[ResellerServiceTier["RESELLER_SERVICE_TIER_SILVER"] = 3] = "RESELLER_SERVICE_TIER_SILVER";
  ResellerServiceTier[ResellerServiceTier["RESELLER_SERVICE_TIER_GOLD"] = 4] = "RESELLER_SERVICE_TIER_GOLD";
  ResellerServiceTier[ResellerServiceTier["RESELLER_SERVICE_TIER_PLATINUM"] = 5] = "RESELLER_SERVICE_TIER_PLATINUM";
  ResellerServiceTier[ResellerServiceTier["RESELLER_SERVICE_TIER_DIAMOND"] = 6] = "RESELLER_SERVICE_TIER_DIAMOND";
  return ResellerServiceTier;
}(ResellerServiceTier || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var AccountStatus = /*#__PURE__*/function (AccountStatus) {
  AccountStatus[AccountStatus["ACCOUNT_STATUS_INVALID"] = 0] = "ACCOUNT_STATUS_INVALID";
  AccountStatus[AccountStatus["ACCOUNT_STATUS_ACTIVE_ACCOUNT"] = 1] = "ACCOUNT_STATUS_ACTIVE_ACCOUNT";
  AccountStatus[AccountStatus["ACCOUNT_STATUS_INACTIVE_ACCOUNT"] = 2] = "ACCOUNT_STATUS_INACTIVE_ACCOUNT";
  return AccountStatus;
}(AccountStatus || {});
var ActivationStatus = /*#__PURE__*/function (ActivationStatus) {
  ActivationStatus[ActivationStatus["ACTIVATION_STATUS_INVALID"] = 0] = "ACTIVATION_STATUS_INVALID";
  ActivationStatus[ActivationStatus["ACTIVATION_STATUS_PENDING_ACTIVATION"] = 1] = "ACTIVATION_STATUS_PENDING_ACTIVATION";
  ActivationStatus[ActivationStatus["ACTIVATION_STATUS_ACTIVE"] = 2] = "ACTIVATION_STATUS_ACTIVE";
  ActivationStatus[ActivationStatus["ACTIVATION_STATUS_PENDING_DEACTIVATION"] = 3] = "ACTIVATION_STATUS_PENDING_DEACTIVATION";
  ActivationStatus[ActivationStatus["ACTIVATION_STATUS_DEACTIVATED"] = 4] = "ACTIVATION_STATUS_DEACTIVATED";
  return ActivationStatus;
}(ActivationStatus || {});
var AlertType = /*#__PURE__*/function (AlertType) {
  AlertType[AlertType["ALERT_TYPE_INVALID"] = 0] = "ALERT_TYPE_INVALID";
  AlertType[AlertType["ALERT_TYPE_CHANGE_SPEND_REQUESTED_ALERT"] = 1] = "ALERT_TYPE_CHANGE_SPEND_REQUESTED_ALERT";
  AlertType[AlertType["ALERT_TYPE_PENDING_ACTIVATION_ALERT"] = 2] = "ALERT_TYPE_PENDING_ACTIVATION_ALERT";
  AlertType[AlertType["ALERT_TYPE_PENDING_DEACTIVATION_ALERT"] = 3] = "ALERT_TYPE_PENDING_DEACTIVATION_ALERT";
  return AlertType;
}(AlertType || {});
var AppType = /*#__PURE__*/function (AppType) {
  AppType[AppType["APP_TYPE_INVALID"] = 0] = "APP_TYPE_INVALID";
  AppType[AppType["APP_TYPE_APP"] = 1] = "APP_TYPE_APP";
  AppType[AppType["APP_TYPE_ADDON"] = 2] = "APP_TYPE_ADDON";
  return AppType;
}(AppType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var ListVendorAccountMetricsSortField = /*#__PURE__*/function (ListVendorAccountMetricsSortField) {
  ListVendorAccountMetricsSortField[ListVendorAccountMetricsSortField["VENDOR_ACCOUNT_METRICS_SORT_FIELD_UNSPECIFIED"] = 0] = "VENDOR_ACCOUNT_METRICS_SORT_FIELD_UNSPECIFIED";
  ListVendorAccountMetricsSortField[ListVendorAccountMetricsSortField["VENDOR_ACCOUNT_METRICS_SORT_FIELD_CREATED"] = 1] = "VENDOR_ACCOUNT_METRICS_SORT_FIELD_CREATED";
  ListVendorAccountMetricsSortField[ListVendorAccountMetricsSortField["VENDOR_ACCOUNT_METRICS_SORT_FIELD_ACCOUNT_COMPANY_NAME"] = 2] = "VENDOR_ACCOUNT_METRICS_SORT_FIELD_ACCOUNT_COMPANY_NAME";
  ListVendorAccountMetricsSortField[ListVendorAccountMetricsSortField["VENDOR_ACCOUNT_METRICS_SORT_FIELD_RESELLER_NAME"] = 3] = "VENDOR_ACCOUNT_METRICS_SORT_FIELD_RESELLER_NAME";
  ListVendorAccountMetricsSortField[ListVendorAccountMetricsSortField["VENDOR_ACCOUNT_METRICS_SORT_FIELD_TOTAL_ACTIVE_ACTIVATIONS"] = 4] = "VENDOR_ACCOUNT_METRICS_SORT_FIELD_TOTAL_ACTIVE_ACTIVATIONS";
  return ListVendorAccountMetricsSortField;
}(ListVendorAccountMetricsSortField || {});
var ListVendorResellerMetricsSortField = /*#__PURE__*/function (ListVendorResellerMetricsSortField) {
  ListVendorResellerMetricsSortField[ListVendorResellerMetricsSortField["VENDOR_RESELLER_METRICS_SORT_FIELD_UNSPECIFIED"] = 0] = "VENDOR_RESELLER_METRICS_SORT_FIELD_UNSPECIFIED";
  ListVendorResellerMetricsSortField[ListVendorResellerMetricsSortField["VENDOR_RESELLER_METRICS_SORT_FIELD_RESELLER_NAME"] = 1] = "VENDOR_RESELLER_METRICS_SORT_FIELD_RESELLER_NAME";
  ListVendorResellerMetricsSortField[ListVendorResellerMetricsSortField["VENDOR_RESELLER_METRICS_SORT_FIELD_TOTAL_ACTIVATIONS"] = 2] = "VENDOR_RESELLER_METRICS_SORT_FIELD_TOTAL_ACTIVATIONS";
  ListVendorResellerMetricsSortField[ListVendorResellerMetricsSortField["VENDOR_RESELLER_METRICS_SORT_FIELD_TOTAL_ACTIVE_ACCOUNTS"] = 3] = "VENDOR_RESELLER_METRICS_SORT_FIELD_TOTAL_ACTIVE_ACCOUNTS";
  ListVendorResellerMetricsSortField[ListVendorResellerMetricsSortField["VENDOR_RESELLER_METRICS_SORT_FIELD_RESELLING_SINCE"] = 4] = "VENDOR_RESELLER_METRICS_SORT_FIELD_RESELLING_SINCE";
  return ListVendorResellerMetricsSortField;
}(ListVendorResellerMetricsSortField || {});
var SortDirection = /*#__PURE__*/function (SortDirection) {
  SortDirection[SortDirection["DESCENDING"] = 0] = "DESCENDING";
  SortDirection[SortDirection["ASCENDING"] = 1] = "ASCENDING";
  return SortDirection;
}(SortDirection || {});
var SortField = /*#__PURE__*/function (SortField) {
  SortField[SortField["TOTAL_ACTIVATIONS"] = 0] = "TOTAL_ACTIVATIONS";
  SortField[SortField["PARTNER_NAME"] = 1] = "PARTNER_NAME";
  SortField[SortField["ENABLED_ON"] = 2] = "ENABLED_ON";
  SortField[SortField["SELLING"] = 3] = "SELLING";
  SortField[SortField["TOTAL_STORE_VIEWS"] = 4] = "TOTAL_STORE_VIEWS";
  SortField[SortField["TOTAL_STORE_CALL_TO_ACTION_EVENTS"] = 5] = "TOTAL_STORE_CALL_TO_ACTION_EVENTS";
  SortField[SortField["TOTAL_DEACTIVATIONS"] = 6] = "TOTAL_DEACTIVATIONS";
  SortField[SortField["TOTAL_PARTNER_VIEWS"] = 7] = "TOTAL_PARTNER_VIEWS";
  return SortField;
}(SortField || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums Index.
// *********************************

function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ResellingProduct {
  static fromProto(proto) {
    let m = new ResellingProduct();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.productId !== 'undefined') {
      toReturn['productId'] = this.productId;
    }
    return toReturn;
  }
}
class Salesperson {
  static fromProto(proto) {
    let m = new Salesperson();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.salespersonId !== 'undefined') {
      toReturn['salespersonId'] = this.salespersonId;
    }
    if (typeof this.salespersonFirstName !== 'undefined') {
      toReturn['salespersonFirstName'] = this.salespersonFirstName;
    }
    if (typeof this.salespersonLastName !== 'undefined') {
      toReturn['salespersonLastName'] = this.salespersonLastName;
    }
    return toReturn;
  }
}
class VendorResellerMetrics {
  static fromProto(proto) {
    let m = new VendorResellerMetrics();
    m = Object.assign(m, proto);
    if (proto.resellingProducts) {
      m.resellingProducts = proto.resellingProducts.map(ResellingProduct.fromProto);
    }
    if (proto.resellingSince) {
      m.resellingSince = new Date(proto.resellingSince);
    }
    if (proto.totalActivations) {
      m.totalActivations = parseInt(proto.totalActivations, 10);
    }
    if (proto.totalActiveAccounts) {
      m.totalActiveAccounts = parseInt(proto.totalActiveAccounts, 10);
    }
    if (proto.salespersonAssignedToReseller) {
      m.salespersonAssignedToReseller = Salesperson.fromProto(proto.salespersonAssignedToReseller);
    }
    if (proto.resellerServiceTier) {
      m.resellerServiceTier = enumStringToValue$2(ResellerServiceTier, proto.resellerServiceTier);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.vendorId !== 'undefined') {
      toReturn['vendorId'] = this.vendorId;
    }
    if (typeof this.resellerPartnerId !== 'undefined') {
      toReturn['resellerPartnerId'] = this.resellerPartnerId;
    }
    if (typeof this.resellerName !== 'undefined') {
      toReturn['resellerName'] = this.resellerName;
    }
    if (typeof this.resellingProducts !== 'undefined' && this.resellingProducts !== null) {
      toReturn['resellingProducts'] = 'toApiJson' in this.resellingProducts ? this.resellingProducts.toApiJson() : this.resellingProducts;
    }
    if (typeof this.resellingSince !== 'undefined' && this.resellingSince !== null) {
      toReturn['resellingSince'] = 'toApiJson' in this.resellingSince ? this.resellingSince.toApiJson() : this.resellingSince;
    }
    if (typeof this.totalActivations !== 'undefined') {
      toReturn['totalActivations'] = this.totalActivations;
    }
    if (typeof this.totalActiveAccounts !== 'undefined') {
      toReturn['totalActiveAccounts'] = this.totalActiveAccounts;
    }
    if (typeof this.salespersonAssignedToReseller !== 'undefined' && this.salespersonAssignedToReseller !== null) {
      toReturn['salespersonAssignedToReseller'] = 'toApiJson' in this.salespersonAssignedToReseller ? this.salespersonAssignedToReseller.toApiJson() : this.salespersonAssignedToReseller;
    }
    if (typeof this.resellerServiceTier !== 'undefined') {
      toReturn['resellerServiceTier'] = this.resellerServiceTier;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AccountData {
  static fromProto(proto) {
    let m = new AccountData();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.companyName !== 'undefined') {
      toReturn['companyName'] = this.companyName;
    }
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    if (typeof this.address2 !== 'undefined') {
      toReturn['address2'] = this.address2;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.zip !== 'undefined') {
      toReturn['zip'] = this.zip;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    return toReturn;
  }
}
class Activation {
  static fromProto(proto) {
    let m = new Activation();
    m = Object.assign(m, proto);
    if (proto.appType) {
      m.appType = enumStringToValue$1(AppType, proto.appType);
    }
    if (proto.activationStatus) {
      m.activationStatus = enumStringToValue$1(ActivationStatus, proto.activationStatus);
    }
    if (proto.eventTime) {
      m.eventTime = new Date(proto.eventTime);
    }
    if (proto.activatedTime) {
      m.activatedTime = new Date(proto.activatedTime);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.appType !== 'undefined') {
      toReturn['appType'] = this.appType;
    }
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    if (typeof this.activationId !== 'undefined') {
      toReturn['activationId'] = this.activationId;
    }
    if (typeof this.activationStatus !== 'undefined') {
      toReturn['activationStatus'] = this.activationStatus;
    }
    if (typeof this.eventTime !== 'undefined' && this.eventTime !== null) {
      toReturn['eventTime'] = 'toApiJson' in this.eventTime ? this.eventTime.toApiJson() : this.eventTime;
    }
    if (typeof this.activatedTime !== 'undefined' && this.activatedTime !== null) {
      toReturn['activatedTime'] = 'toApiJson' in this.activatedTime ? this.activatedTime.toApiJson() : this.activatedTime;
    }
    if (typeof this.addonId !== 'undefined') {
      toReturn['addonId'] = this.addonId;
    }
    if (typeof this.orderFormSubmissionId !== 'undefined') {
      toReturn['orderFormSubmissionId'] = this.orderFormSubmissionId;
    }
    return toReturn;
  }
}
class Alert {
  static fromProto(proto) {
    let m = new Alert();
    m = Object.assign(m, proto);
    if (proto.alertType) {
      m.alertType = enumStringToValue$1(AlertType, proto.alertType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.activationId !== 'undefined') {
      toReturn['activationId'] = this.activationId;
    }
    if (typeof this.alertType !== 'undefined') {
      toReturn['alertType'] = this.alertType;
    }
    return toReturn;
  }
}
class VendorAccountMetrics {
  static fromProto(proto) {
    let m = new VendorAccountMetrics();
    m = Object.assign(m, proto);
    if (proto.accountData) {
      m.accountData = AccountData.fromProto(proto.accountData);
    }
    if (proto.activations) {
      m.activations = proto.activations.map(Activation.fromProto);
    }
    if (proto.totalActiveActivations) {
      m.totalActiveActivations = parseInt(proto.totalActiveActivations, 10);
    }
    if (proto.accountStatus) {
      m.accountStatus = enumStringToValue$1(AccountStatus, proto.accountStatus);
    }
    if (proto.alerts) {
      m.alerts = proto.alerts.map(Alert.fromProto);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.vendorId !== 'undefined') {
      toReturn['vendorId'] = this.vendorId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.accountData !== 'undefined' && this.accountData !== null) {
      toReturn['accountData'] = 'toApiJson' in this.accountData ? this.accountData.toApiJson() : this.accountData;
    }
    if (typeof this.resellerPartnerId !== 'undefined') {
      toReturn['resellerPartnerId'] = this.resellerPartnerId;
    }
    if (typeof this.resellerName !== 'undefined') {
      toReturn['resellerName'] = this.resellerName;
    }
    if (typeof this.activations !== 'undefined' && this.activations !== null) {
      toReturn['activations'] = 'toApiJson' in this.activations ? this.activations.toApiJson() : this.activations;
    }
    if (typeof this.totalActiveActivations !== 'undefined') {
      toReturn['totalActiveActivations'] = this.totalActiveActivations;
    }
    if (typeof this.accountStatus !== 'undefined') {
      toReturn['accountStatus'] = this.accountStatus;
    }
    if (typeof this.alerts !== 'undefined' && this.alerts !== null) {
      toReturn['alerts'] = 'toApiJson' in this.alerts ? this.alerts.toApiJson() : this.alerts;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class GetMultiVendorResellerMetricsRequest {
  static fromProto(proto) {
    let m = new GetMultiVendorResellerMetricsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.vendorId !== 'undefined') {
      toReturn['vendorId'] = this.vendorId;
    }
    if (typeof this.resellerPartnerIds !== 'undefined') {
      toReturn['resellerPartnerIds'] = this.resellerPartnerIds;
    }
    return toReturn;
  }
}
class GetMultiVendorResellerMetricsResponse {
  static fromProto(proto) {
    let m = new GetMultiVendorResellerMetricsResponse();
    m = Object.assign(m, proto);
    if (proto.vendorResellerMetrics) {
      m.vendorResellerMetrics = proto.vendorResellerMetrics.map(VendorResellerMetrics.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.vendorResellerMetrics !== 'undefined' && this.vendorResellerMetrics !== null) {
      toReturn['vendorResellerMetrics'] = 'toApiJson' in this.vendorResellerMetrics ? this.vendorResellerMetrics.toApiJson() : this.vendorResellerMetrics;
    }
    return toReturn;
  }
}
class GetPartnerEngagementRequest {
  static fromProto(proto) {
    let m = new GetPartnerEngagementRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class GetPartnerEngagementResponse {
  static fromProto(proto) {
    let m = new GetPartnerEngagementResponse();
    m = Object.assign(m, proto);
    if (proto.partnerEngagement) {
      m.partnerEngagement = PartnerEngagement.fromProto(proto.partnerEngagement);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerEngagement !== 'undefined' && this.partnerEngagement !== null) {
      toReturn['partnerEngagement'] = 'toApiJson' in this.partnerEngagement ? this.partnerEngagement.toApiJson() : this.partnerEngagement;
    }
    return toReturn;
  }
}
class ListPartnerEngagementRequest {
  static fromProto(proto) {
    let m = new ListPartnerEngagementRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    if (proto.sortOptions) {
      m.sortOptions = SortOptions.fromProto(proto.sortOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.sortOptions !== 'undefined' && this.sortOptions !== null) {
      toReturn['sortOptions'] = 'toApiJson' in this.sortOptions ? this.sortOptions.toApiJson() : this.sortOptions;
    }
    return toReturn;
  }
}
class ListPartnerEngagementResponse {
  static fromProto(proto) {
    let m = new ListPartnerEngagementResponse();
    m = Object.assign(m, proto);
    if (proto.partnerEngagement) {
      m.partnerEngagement = proto.partnerEngagement.map(PartnerEngagement.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerEngagement !== 'undefined' && this.partnerEngagement !== null) {
      toReturn['partnerEngagement'] = 'toApiJson' in this.partnerEngagement ? this.partnerEngagement.toApiJson() : this.partnerEngagement;
    }
    return toReturn;
  }
}
class ListVendorAccountMetricsFilterOptions {
  static fromProto(proto) {
    let m = new ListVendorAccountMetricsFilterOptions();
    m = Object.assign(m, proto);
    if (proto.activationStatuses) {
      m.activationStatuses = proto.activationStatuses.map(v => enumStringToValue(ActivationStatus, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.resellerPartnerIds !== 'undefined') {
      toReturn['resellerPartnerIds'] = this.resellerPartnerIds;
    }
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    if (typeof this.appIds !== 'undefined') {
      toReturn['appIds'] = this.appIds;
    }
    if (typeof this.activationStatuses !== 'undefined') {
      toReturn['activationStatuses'] = this.activationStatuses;
    }
    if (typeof this.trimActivationsByFilters !== 'undefined') {
      toReturn['trimActivationsByFilters'] = this.trimActivationsByFilters;
    }
    return toReturn;
  }
}
class ListVendorAccountMetricsRequest {
  static fromProto(proto) {
    let m = new ListVendorAccountMetricsRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    if (proto.sortOptions) {
      m.sortOptions = ListVendorAccountMetricsSortOptions.fromProto(proto.sortOptions);
    }
    if (proto.filterOptions) {
      m.filterOptions = ListVendorAccountMetricsFilterOptions.fromProto(proto.filterOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.vendorId !== 'undefined') {
      toReturn['vendorId'] = this.vendorId;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.sortOptions !== 'undefined' && this.sortOptions !== null) {
      toReturn['sortOptions'] = 'toApiJson' in this.sortOptions ? this.sortOptions.toApiJson() : this.sortOptions;
    }
    if (typeof this.filterOptions !== 'undefined' && this.filterOptions !== null) {
      toReturn['filterOptions'] = 'toApiJson' in this.filterOptions ? this.filterOptions.toApiJson() : this.filterOptions;
    }
    return toReturn;
  }
}
class ListVendorAccountMetricsResponse {
  static fromProto(proto) {
    let m = new ListVendorAccountMetricsResponse();
    m = Object.assign(m, proto);
    if (proto.vendorAccountMetrics) {
      m.vendorAccountMetrics = proto.vendorAccountMetrics.map(VendorAccountMetrics.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.vendorAccountMetrics !== 'undefined' && this.vendorAccountMetrics !== null) {
      toReturn['vendorAccountMetrics'] = 'toApiJson' in this.vendorAccountMetrics ? this.vendorAccountMetrics.toApiJson() : this.vendorAccountMetrics;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class ListVendorAccountMetricsSortOptions {
  static fromProto(proto) {
    let m = new ListVendorAccountMetricsSortOptions();
    m = Object.assign(m, proto);
    if (proto.sortField) {
      m.sortField = enumStringToValue(ListVendorAccountMetricsSortField, proto.sortField);
    }
    if (proto.sortDirection) {
      m.sortDirection = enumStringToValue(SortDirection, proto.sortDirection);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sortField !== 'undefined') {
      toReturn['sortField'] = this.sortField;
    }
    if (typeof this.sortDirection !== 'undefined') {
      toReturn['sortDirection'] = this.sortDirection;
    }
    return toReturn;
  }
}
class ListVendorResellerMetricsFilters {
  static fromProto(proto) {
    let m = new ListVendorResellerMetricsFilters();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    return toReturn;
  }
}
class ListVendorResellerMetricsRequest {
  static fromProto(proto) {
    let m = new ListVendorResellerMetricsRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    if (proto.sortOptions) {
      m.sortOptions = ListVendorResellerMetricsSortOptions.fromProto(proto.sortOptions);
    }
    if (proto.filters) {
      m.filters = ListVendorResellerMetricsFilters.fromProto(proto.filters);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.vendorId !== 'undefined') {
      toReturn['vendorId'] = this.vendorId;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.sortOptions !== 'undefined' && this.sortOptions !== null) {
      toReturn['sortOptions'] = 'toApiJson' in this.sortOptions ? this.sortOptions.toApiJson() : this.sortOptions;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    return toReturn;
  }
}
class ListVendorResellerMetricsResponse {
  static fromProto(proto) {
    let m = new ListVendorResellerMetricsResponse();
    m = Object.assign(m, proto);
    if (proto.vendorResellerMetrics) {
      m.vendorResellerMetrics = proto.vendorResellerMetrics.map(VendorResellerMetrics.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.vendorResellerMetrics !== 'undefined' && this.vendorResellerMetrics !== null) {
      toReturn['vendorResellerMetrics'] = 'toApiJson' in this.vendorResellerMetrics ? this.vendorResellerMetrics.toApiJson() : this.vendorResellerMetrics;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class ListVendorResellerMetricsSortOptions {
  static fromProto(proto) {
    let m = new ListVendorResellerMetricsSortOptions();
    m = Object.assign(m, proto);
    if (proto.sortField) {
      m.sortField = enumStringToValue(ListVendorResellerMetricsSortField, proto.sortField);
    }
    if (proto.sortDirection) {
      m.sortDirection = enumStringToValue(SortDirection, proto.sortDirection);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sortField !== 'undefined') {
      toReturn['sortField'] = this.sortField;
    }
    if (typeof this.sortDirection !== 'undefined') {
      toReturn['sortDirection'] = this.sortDirection;
    }
    return toReturn;
  }
}
class SortOptions {
  static fromProto(proto) {
    let m = new SortOptions();
    m = Object.assign(m, proto);
    if (proto.direction) {
      m.direction = enumStringToValue(SortDirection, proto.direction);
    }
    if (proto.field) {
      m.field = enumStringToValue(SortField, proto.field);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.direction !== 'undefined') {
      toReturn['direction'] = this.direction;
    }
    if (typeof this.field !== 'undefined') {
      toReturn['field'] = this.field;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects Index.
// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'marketplace-analytics-api.vendasta-local.com',
  'test': '',
  'demo': 'marketplace-analytics-demo.apigateway.co',
  'prod': 'marketplace-analytics-prod.apigateway.co',
  'production': 'marketplace-analytics-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(t) {
    return new (t || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let PartnerEngagementApiService = /*#__PURE__*/(() => {
  class PartnerEngagementApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getPartnerEngagement(r) {
      const request = r.toApiJson ? r : new GetPartnerEngagementRequest(r);
      return this.http.post(this._host + "/marketplaceanalytics.v1.PartnerEngagementService/GetPartnerEngagement", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetPartnerEngagementResponse.fromProto(resp)));
    }
    listPartnerEngagement(r) {
      const request = r.toApiJson ? r : new ListPartnerEngagementRequest(r);
      return this.http.post(this._host + "/marketplaceanalytics.v1.PartnerEngagementService/ListPartnerEngagement", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListPartnerEngagementResponse.fromProto(resp)));
    }
    listVendorResellerMetrics(r) {
      const request = r.toApiJson ? r : new ListVendorResellerMetricsRequest(r);
      return this.http.post(this._host + "/marketplaceanalytics.v1.PartnerEngagementService/ListVendorResellerMetrics", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListVendorResellerMetricsResponse.fromProto(resp)));
    }
    listVendorAccountMetrics(r) {
      const request = r.toApiJson ? r : new ListVendorAccountMetricsRequest(r);
      return this.http.post(this._host + "/marketplaceanalytics.v1.PartnerEngagementService/ListVendorAccountMetrics", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListVendorAccountMetricsResponse.fromProto(resp)));
    }
    getMultiVendorResellerMetrics(r) {
      const request = r.toApiJson ? r : new GetMultiVendorResellerMetricsRequest(r);
      return this.http.post(this._host + "/marketplaceanalytics.v1.PartnerEngagementService/GetMultiVendorResellerMetrics", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiVendorResellerMetricsResponse.fromProto(resp)));
    }
  }
  PartnerEngagementApiService.ɵfac = function PartnerEngagementApiService_Factory(t) {
    return new (t || PartnerEngagementApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  PartnerEngagementApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: PartnerEngagementApiService,
    factory: PartnerEngagementApiService.ɵfac,
    providedIn: 'root'
  });
  return PartnerEngagementApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PartnerEngagementService = /*#__PURE__*/(() => {
  class PartnerEngagementService {
    constructor(api) {
      this.api = api;
    }
    getPartnerEngagement(partnerId, appId) {
      return this.api.getPartnerEngagement({
        partnerId,
        appId
      }).pipe(map(resp => resp.partnerEngagement));
    }
    listPartnerEngagement(appId, cursor, pageSize, sortOptions) {
      return this.api.listPartnerEngagement({
        appId,
        cursor,
        pageSize,
        sortOptions
      }).pipe(map(resp => resp.partnerEngagement));
    }
  }
  PartnerEngagementService.ɵfac = function PartnerEngagementService_Factory(t) {
    return new (t || PartnerEngagementService)(i0.ɵɵinject(PartnerEngagementApiService));
  };
  PartnerEngagementService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: PartnerEngagementService,
    factory: PartnerEngagementService.ɵfac,
    providedIn: 'root'
  });
  return PartnerEngagementService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Index.
// *********************************

/**
 * Generated bundle index. Do not edit.
 */

export { AccountData, AccountStatus, Activation, ActivationStatus, Alert, AlertType, AppType, GetMultiVendorResellerMetricsRequest, GetMultiVendorResellerMetricsResponse, GetPartnerEngagementRequest, GetPartnerEngagementResponse, ListPartnerEngagementRequest, ListPartnerEngagementResponse, ListVendorAccountMetricsFilterOptions, ListVendorAccountMetricsRequest, ListVendorAccountMetricsResponse, ListVendorAccountMetricsSortField, ListVendorAccountMetricsSortOptions, ListVendorResellerMetricsFilters, ListVendorResellerMetricsRequest, ListVendorResellerMetricsResponse, ListVendorResellerMetricsSortField, ListVendorResellerMetricsSortOptions, PartnerEngagement, PartnerEngagementApiService, PartnerEngagementService, ResellerServiceTier, ResellingProduct, Salesperson, SortDirection, SortField, SortOptions, VendorAccountMetrics, VendorResellerMetrics };
